export const nisParticipantHeaderSiteCoreKeys = {
  nisParticipantHeaderTitle:
    "ProgramAndParticipants.CreateNewNISParticipant.NISParticipantHeader",
  convertToProgramButton:
    "CreateNewNISParticipant.NISParticipantHeader.ConvertToProgramButton",
  convertToProgramConfirmationMessage:
    "CreateNewNISParticipant.NISParticipantHeader.ConvertToProgramConfirmationMessage",
  editNISParticipantHeader:
    "CreateNewNISParticipant.NISParticipantHeader.EditNISParticipantHeader",
  viewNISParticipantHeader:
    "CreateNewNISParticipant.NISParticipantHeader.ViewNISParticipantHeader",
} as const;

export const createNISParticipantProfileSiteCoreKeys = {
  profileTitle: "ProgramAndParticipants.CreateNewNISParticipant.Profile",
  jobTitle: "CreateNewNISParticipant.Profile.JobTitle",
  participantEmail: "CreateNewNISParticipant.Profile.ParticipantEmail",
  participantFirstName: "CreateNewNISParticipant.Profile.ParticipantFirstName",
  participantLastName: "CreateNewNISParticipant.Profile.ParticipantLastName",
  participantMobile: "CreateNewNISParticipant.Profile.ParticipantMobile",
  participantWorkEmail: "CreateNewNISParticipant.Profile.ParticipantWorkEmail",
  nisID: "CreateNewNISParticipant.Profile.NISID",
  nisStatus: "CreateNewNISParticipant.Profile.NISStatus",
  programKey: "CreateNewNISParticipant.Profile.ProgramKey",
  nisParticipantStatusList:
    "CreateNewNISParticipant.Profile.NISParticipantStatusList",
  jobTitleValidationMessage:
    "CreateNewNISParticipant.Profile.JobTitleValidationMessage",
  nisParticipantCreatedSuccessMessage:
    "CreateNewNISParticipant.Profile.NISParticipantCreatedSuccessMessage",
  nisParticipantDetailsAlreadyExistMessage:
    "CreateNewNISParticipant.Profile.NISParticipantDetailsAlreadyExistMessage",
  matchingNISParticipantEntryAlreadyExistMessage:
    "CreateNewNISParticipant.Profile.MatchingNISParticipantEntryAlreadyExistMessage",
  updateNISParticipantConfirmationMessage:
    "CreateNewNISParticipant.Profile.UpdateNISParticipantConfirmationMessage",
  nisParticipantUpdatedMessage:
    "CreateNewNISParticipant.Profile.NISParticipantUpdatedMessage",
} as const;

export const createNISParticipantProfessionalDetailsSiteCoreKeys = {
  professionalDetailsTitle:
    "ProgramAndParticipants.CreateNewNISParticipant.ProfessionalDetails",
  clientEmployer: "CreateNewNISParticipant.ProfessionalDetails.Client-Employer",
  clientEmployerOther:
    "CreateNewNISParticipant.ProfessionalDetails.Client-Employer-Other",
  country: "CreateNewNISParticipant.ProfessionalDetails.Country",
  employeeId: "CreateNewNISParticipant.ProfessionalDetails.EmployeeID",
  releaseDate: "CreateNewNISParticipant.ProfessionalDetails.ReleaseDate",
  hrContact: "CreateNewNISParticipant.ProfessionalDetails.HRContact",
  hrContactEmailIdOther:
    "CreateNewNISParticipant.ProfessionalDetails.HRContactEmailID-Other",
  hrContactNameOther:
    "CreateNewNISParticipant.ProfessionalDetails.HRContactName-Other",
  projectManager: "CreateNewNISParticipant.ProfessionalDetails.ProjectManager",
  severanceStatusSigned:
    "CreateNewNISParticipant.ProfessionalDetails.SeveranceStatusSigned",
  severanceStatusList:
    "CreateNewNISParticipant.ProfessionalDetails.SeveranceStatusList",
} as const;

export const createNISParticipantAddressDetailsSiteCoreKeys = {
  addressDetailsTitle:
    "ProgramAndParticipants.CreateNewNISParticipant.AddressDetails",
  addressSubTitle: "CreateNewNISParticipant.AddressDetails.AddressSubTitle",
  address1: "CreateNewNISParticipant.AddressDetails.Address1",
  address2: "CreateNewNISParticipant.AddressDetails.Address2",
  address3: "CreateNewNISParticipant.AddressDetails.Address3",
  country: "CreateNewNISParticipant.AddressDetails.Country",
  city: "CreateNewNISParticipant.AddressDetails.City",
  stateProvince: "CreateNewNISParticipant.AddressDetails.State-Province",
  postalCode: "CreateNewNISParticipant.AddressDetails.PostalCode",
  stateRegionProvinceListPrefix:
    "CreateNewNISParticipant.AddressDetails.StateRegionProvinceList",
} as const;

export const createNISParticipantNISStatusSiteCoreKeys = {
  nisStatusTitle: "ProgramAndParticipants.CreateNewNISParticipant.NISStatus",
  currentStatus: "CreateNewNISParticipant.NISStatus.CurrentStatus",
  changeStatusPopupHeader:
    "CreateNewNISParticipant.NISStatus.ChangeStatusPopupHeader",
  createdModifiedByTableColumn:
    "CreateNewNISParticipant.NISStatus.Created-ModifiedByTableColumn",
  createdModifiedDateTableColumn:
    "CreateNewNISParticipant.NISStatus.Created-ModifiedDateTableColumn",
  notesPopupLabel: "CreateNewNISParticipant.NISStatus.NotesPopupLabel",
  notesTableColumn: "CreateNewNISParticipant.NISStatus.NotesTableColumn",
  statusPopupDropdownLabel:
    "CreateNewNISParticipant.NISStatus.StatusPopupDropdownLabel",
  statusTableColumn: "CreateNewNISParticipant.NISStatus.StatusTableColumn",
  nisParticipantStatusList:
    "CreateNewNISParticipant.NISStatus.NISParticipantStatusList",
} as const;
